import { Card } from "@/components/ui/card";

export function SkeletonCard({ className = "" }) {
  return (
    <Card className={`p-5 border-slate-200 shadow-none ${className}`}>
      <div className="animate-pulse space-y-3">
        <div className="h-3 bg-slate-200 rounded w-1/3" />
        <div className="h-8 bg-slate-200 rounded w-1/2" />
        <div className="h-2 bg-slate-100 rounded w-full" />
      </div>
    </Card>
  );
}

export function SkeletonRow() {
  return (
    <div className="animate-pulse p-3 flex items-center gap-3">
      <div className="w-9 h-9 rounded-full bg-slate-200" />
      <div className="flex-1 space-y-2">
        <div className="h-3 bg-slate-200 rounded w-1/3" />
        <div className="h-2 bg-slate-100 rounded w-1/2" />
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="p-12 flex flex-col items-center justify-center text-center" data-testid="empty-state">
      {Icon && (
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-slate-400" />
        </div>
      )}
      <h3 className="font-[Outfit] font-semibold text-slate-900 text-lg">{title}</h3>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
